import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 费用tab-运价表查询
export function queryEffectivePriceFcl(data) {
  return request({
    url: URL.price.queryEffectivePriceFcl,
    method: 'post',
    data
  })
}
// 整箱运价输入-待审核列表查询
export function queryPendingPriceFcl(data) {
  return request({
    url: URL.price.queryPendingPriceFcl,
    method: 'post',
    data
  })
}
// 整箱运价输入-保存运价信息
export function savePriceFcl(data) {
  return request({
    url: URL.price.savePriceFcl,
    method: 'post',
    data
  })
}
// 整箱运价输入-修改移除运价信息
export function inactivePriceFcls(data) {
  return request({
    url: URL.price.inactivePriceFcls,
    method: 'post',
    data
  })
}
// 整箱运价输入-修改运价信息
export function updatePriceStateOfPriceFcls(data) {
  return request({
    url: URL.price.updatePriceStateOfPriceFcls,
    method: 'post',
    data
  })
}
// 整箱运价输入-删除运价信息
export function deletePriceFcls(data) {
  return request({
    url: URL.price.deletePriceFcls,
    method: 'post',
    data
  })
}

// 整箱运价输入-修改运价信息-不接
export function rejectPriceFcls(data) {
  return request({
    url: URL.price.rejectPriceFcls,
    method: 'post',
    data
  })
}
export function queryByPriceNo(params) {
  return request({
    url: URL.price.queryByPriceNo,
    method: 'get',
    params
  })
}

export function queryOpenPriceFcls(data) {
  return request({
    url: URL.price.queryOpenPriceFcls,
    method: 'post',
    data
  })
}
// 运价审核
export function approvePriceFclsWithAllTiers(data) {
  return request({
    url: URL.price.approvePriceFclsWithAllTiers,
    method: 'post',
    data
  })
}

// 运价审核-手工加价审核
export function approvePriceFcls(data) {
  return request({
    url: URL.price.approvePriceFcls,
    method: 'post',
    data
  })
}
// 整箱运价统计，按状态、按时间列表查询
export function getPriceStat(data) {
  return request({
    url: URL.price.getPriceStat,
    method: 'post',
    data
  })
}
// 整箱运价统计，按状态、按时间列表查询
export function getPriceFCLStat_Port(data) {
  return request({
    url: URL.price.getPriceFCLStat_Port,
    method: 'post',
    data
  })
}
// 整箱运价输入-excel校验
export function checkPodFromExcel(file) {
  const data = new FormData()
  data.append('file', file)
  return request({
    url: URL.price.checkPodFromExcel,
    method: 'post',
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    data
  })
}

// 整箱运价历史-列表查询
export function queryHistoryPriceFcl(data) {
  return request({
    url: URL.price.queryHistoryPriceFcl,
    method: 'post',
    data
  })
}
// 运价表-列表查询
export function queryTariffTable(data) {
  return request({
    url: URL.price.queryTariffTable,
    method: 'post',
    data
  })
}

// 整箱运价输入-excel校验
export function transformedTariffTableExcel(data) {
  return request({
    url: URL.price.transformedTariffTableExcel,
    method: 'post',
    responseType: 'blob',
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    data
  })
}

// 船公司约号列表查询
export function findByshippingContractNo(data) {
  return request({
    url: URL.sys.findByshippingContractNo,
    method: 'post',
    data
  })
}

// 根据船公司约号查询
export function shippingContractPage(data) {
  return request({
    url: URL.sys.shippingContractPage,
    method: 'post',
    data
  })
}

// 新增或修改船公司约号
export function saveShippingContract(data) {
  return request({
    url: URL.sys.saveShippingContract,
    method: 'post',
    data
  })
}

// 批量删除
export function deleteShippingContract(data) {
  return request({
    url: URL.sys.deleteShippingContract,
    method: 'post',
    data
  })
}

// 启用 禁用
export function enableShippingContract(data) {
  return request({
    url: URL.sys.enableShippingContract,
    method: 'post',
    data
  })
}
// 根据uuid 查询NAC
export function getNacInfo(data) {
  return request({
    url: URL.sys.getNacInfo,
    method: 'post',
    data
  })
}

// 查询船公司约号
export function getShippingContract(data) {
  return request({
    url: URL.sys.getShippingContract,
    method: 'post',
    data
  })
}

export function isExistContractNumber(data) {
  return request({
    url: URL.sys.isExistContractNumber,
    method: 'post',
    data
  })
}

